import { Course, DefaultCourse } from '../courses/course';

export interface Discount {
  id: number;
  code: string;
  start_date: string;
  end_date: string;
  is_dollars: boolean;
  is_dollars_display: string;
  amount: number;
  raw_amount: number;
  min_discount: number;
  max_discount: number;
  gift_certificate_stack: boolean;
  enabled: boolean;
  min_players: number;
  max_players: number;
  courses: Course[];
  apply_to_service_fee: boolean;
  apply_to_rental_clubs: boolean;
}

const DEFAULT_DISCOUNT: Discount = {
  id: -1,
  code: '',
  start_date: '',
  end_date: '',
  is_dollars: false,
  is_dollars_display: '',
  amount: 0,
  raw_amount: 0,
  min_discount: 0,
  max_discount: 0,
  gift_certificate_stack: false,
  enabled: false,
  min_players: 0,
  max_players: 0,
  courses: [],
  apply_to_service_fee: false,
  apply_to_rental_clubs: false
};

export function DefaultDiscount(): Discount {
  return JSON.parse(JSON.stringify(DEFAULT_DISCOUNT));
}

export function ComputeDiscountAmount(
  discount: Discount,
  chargeAmount: number,
  serviceFeeAmount: number,
  rentalClubsAmount: number
): number {
  if (chargeAmount === 0 || discount.raw_amount === 0) {
    return 0;
  }

  const amount = discount.raw_amount / 100;
  if (discount.is_dollars) {
    if (chargeAmount > amount) {
      return amount;
    }
    return chargeAmount;
  }

  // %
  let totalAmount = chargeAmount;
  if (discount.apply_to_service_fee) {
    totalAmount += serviceFeeAmount
  }
  if (discount.apply_to_rental_clubs) {
    totalAmount += rentalClubsAmount
  }

  let discountAmount = amount * totalAmount;
  // Uncomment after fixing discount min and max format number or formatted string
  // if (discountAmount < discount.min_discount) {
  //   discountAmount = discount.min_discount
  // }
  // if (discountAmount > discount.max_discount) {
  //   discountAmount = discount.max_discount
  // }

  return discountAmount;
}
